import _ from 'lodash'
import {RejectionDetails} from '@/modules/reservation/model/CreateListResult';

export enum BulkProcessState {
    Waiting,
    Preparing,
    Inserting,
    Finished,
}

/**
 * Proceso de registro masivo de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class BulkProcess {
    public readonly id = _.uniqueId('reservation_bulk_process_')
    public readonly start = Date.now()
    public readonly itemsPerLot = 50

    public state = BulkProcessState.Waiting

    /**
     * Número de lotes en los que se dividirá la lista actual de reservas
     */
    public get lots () {
        return Math.ceil(this.totalToInsert / this.itemsPerLot)
    }

    /**
     * Número total de reservas a insertar
     */
    public totalToInsert = 0

    public inserted = 0
    public rejected = 0
    public progress = 0
}
